import React from 'react';
import { useParams } from 'react-router-dom';

import TicketingConfigurationContainer from '@totem/components/ticketing/configuration/ticketingConfigurationContainer';
import TaskContainer from '@totem/components/ticketing/details/tasks/taskContainer';
import TicketContainer from '@totem/components/ticketing/details/ticketContainer';
import TicketDetailsLayout from '@totem/components/ticketing/details/ticketDetailsLayout';

const TicketDetailsPage = () => {
  const { id } = useParams();

  return (
    <TicketContainer ticketId={id}>
      <TaskContainer>
        <TicketingConfigurationContainer>
          <TicketDetailsLayout />
        </TicketingConfigurationContainer>
      </TaskContainer>
    </TicketContainer>
  );
};

export default TicketDetailsPage;
